// aws-exports.js
// AWS Cognito configuration for Amplify v5
const awsconfig = {
  Auth: {
    region: 'us-east-1', // US East region
    userPoolId: 'us-east-1_C0fdh1u5t', // Your new User Pool ID in us-east-1
    userPoolWebClientId: '25hfbmls764po68odtpdoqngpm', // Your new App Client ID (without secret)
    mandatorySignIn: true,
    authenticationFlowType: 'USER_SRP_AUTH',
  }
};

export default awsconfig;
